export function emptyCheck(vueEntity: any, value: any, checkFieldId: string, messageCode: string): boolean {
  if (value && value !== '') {
    return true;
  } else {
    alert(vueEntity.$t(messageCode));
    vueEntity.$refs[checkFieldId].focus();
    return false;
  }
}

export function greaterThen(vueEntity: any, value: any, checkVal: any, checkFieldId: string, messageCode: string): boolean {
  if (value <= checkVal) {
    alert(vueEntity.$t(messageCode));
    vueEntity.$refs[checkFieldId].focus();
    return false;
  }
  return true;
}

export function lessThen(vueEntity: any, value: any, checkVal: any, checkFieldId: string, messageCode: string): boolean {
  if (value >= checkVal) {
    alert(vueEntity.$t(messageCode));
    vueEntity.$refs[checkFieldId].focus();
    return false;
  }
  return true;
}

export function between(vueEntity: any, aValue: any, bValue: any, checkFieldId: string, messageCode: string): boolean {
  if (aValue > bValue) {
    alert(vueEntity.$t(messageCode));
    vueEntity.$refs[checkFieldId].focus();
    return false;
  }
  return true;
}

export function isEmailValidated(email: string): boolean {
  const regexTestResult = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
  if (regexTestResult) {
    return true;
  }
  return false;
}

export function isMobileNoValidated (mobileNo: string): boolean {
  // 000-0000-0000, 000-000-0000, 00000000000 (11), 0000000000 (10)
  if (mobileNo.match( /^[0-9]{3}[-]+[0-9]{4}[-]+[0-9]{4}$/ )
      || mobileNo.match( /^[0-9]{3}[-]+[0-9]{3}[-]+[0-9]{4}$/ )
      || mobileNo.match( /^\d{11}$/ )
      || mobileNo.match( /^\d{10}$/ )) {
    return true;
  }

  return false;
}

export function isEveryEmptyString(...args: string[]): boolean{
  return args.map(target => target.trim()).every(target => target === '')
}

export function isSomeEmptyString(...args: string[]): boolean{
  return args.map(target => target.trim()).some(target => target === '')
}

export enum resultNcpPolicyPasswordEnum {
  SUCCESS, NOT_ALLOW_SPECAIL, AT_LEAST2, AT_LEAST3
}
export function validateNcpPolicyPassword (password: string) {
  const patternNumber = /[0-9]/g;
  const patternEnglish = /[a-zA-Z]/gi;
  const patternSpecial = /[!@#$%^&+=\-_.()]/g;

  const checkNumber = patternNumber.test(password) ? 1 : 0;
  const checkEnglish = patternEnglish.test(password) ? 1 : 0;
  const checkSpecial = patternSpecial.test(password) ? 1 : 0;
  const checkSum = checkNumber + checkEnglish + checkSpecial;

  const filteringPassword = password.replace(patternNumber, '')
    .replace(patternEnglish, '')
    .replace(patternSpecial, '');

  let result = resultNcpPolicyPasswordEnum.SUCCESS;
  if (filteringPassword.length > 0) {
    result = resultNcpPolicyPasswordEnum.NOT_ALLOW_SPECAIL;
  } else {
    if (password.length < 10) {
      if (checkSum < 3) {
        result = resultNcpPolicyPasswordEnum.AT_LEAST3;
      }
    } else if (checkSum < 2) {
      result = resultNcpPolicyPasswordEnum.AT_LEAST2;
    }
  }

  return result;
}

/**
 * static of(target, message)
 * @param {string} target : 검증 실패한 target input 의 attribute name
 * @param {string} message : 검증 실패 시 노출할 메시지
 *
 * 오류를 핸들링하는 최상위에서 아래와 같이 활용할 수 있습니다.
 * catch(error) {
 *   if (error?.target) {
 *     - target 이 속한 component 의 focus 메소드 호출
 *     - alert(error.message);
 *     ex ) ConditionRegistration > handleConditionRegistrationSubmit method
 *   }
 * }
 */
export class ThrowInputValidationError extends Error {
  private readonly target: string;
  constructor(target, message) {
    super(message);
    this.target = target;
  }
  static of(target, message) {
    throw new ThrowInputValidationError(target, message);
  }
}
